import { useMemo } from 'react';
import { AttachmentResult } from '@sdir/httpclient/lib/clients/aps/application';
import { useCurrentApplication } from '../hooks';
import { attachmentsForRequirement } from './certreqAttachments';
import { buildRequirementKey } from './requirementKeys';

export type RequirementAttachments = {
  /** `certreq:{kode}#{requirementId}`, eller null når kravet mangler id. */
  requirementKey: string | null;
  /** Vedleggene søkeren har lastet opp på dette kravet. */
  attachments: AttachmentResult[];
};

/**
 * Vedleggene som hører til ett krav i kravtreet.
 *
 * Brukes både av opplastingsboksen og av «Dokumentert»-markeringen, slik at de
 * to alltid ser samme filer.
 */
export const useRequirementAttachments = (
  certificateCode?: string | null,
  requirementId?: string | null
): RequirementAttachments => {
  const { application } = useCurrentApplication();
  const requirementKey = buildRequirementKey(certificateCode, requirementId);

  const attachments = useMemo(
    () => attachmentsForRequirement(application.result, requirementKey),
    [application.result, requirementKey]
  );

  return { requirementKey, attachments };
};
